module.exports = __webpack_public_path__ + "img/600x100.54fbfc0c.png";